import type { ReactNode } from 'react';

import Video from '../marketing/Video';
import { DialogBody, DialogRoot, DialogTitle } from '../tailwind-ui';

export interface Props {
  show: boolean;
  onClose: () => void;
  link?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
}

export default function Presentation(props: Props) {
  const { show, onClose, link, title, description, children } = props;

  return (
    <DialogRoot
      open={show}
      onOpenChange={(open) => {
        if (open) return;
        return onClose();
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody className="max-h-full text-neutral-500 space-y-2 xl:w-[1200px] w-[90vw]">
        {link && <Video link={link} />}

        <p className="text-justify text-sm sm:text-base text-neutral-500">
          {description || children}
        </p>
      </DialogBody>
    </DialogRoot>
  );
}
